import _ from 'lodash'
import React from 'react'
import { Link } from 'react-router-dom'

import UnitTemplateMini from './unit_template_mini'
import UnitTemplateMinisTable from './unitTemplateMinisTable'

import { DropdownInput, getPageTitle } from '../../../../Shared/index'
import AssignmentFlowNavigation from '../assignment_flow_navigation'
import { ACTIVITY_PACK_TYPES, CREATE_YOUR_OWN_ID, DAILY_PROOFREADING, DIAGNOSTIC_CAPITALIZED, LANGUAGE_SKILLS, READING_TEXTS, WHOLE_CLASS_LESSONS } from '../../../../Shared'

const ALL = 'All'
// Cumulative 2026 grade-band filters ("this grade and up"). A pack matches a
// filter if any of its activities' grade bands is in that filter's `bands` set
// (overlap), driven by the pack's serialized `grade_band_names`.
export const GRADE_BAND_FILTER_OPTIONS = [
  { label: '3rd-12th', bands: ['3-5', '6-8', '8-12'] },
  { label: '6th-12th', bands: ['6-8', '8-12'] },
  { label: '8th-12th', bands: ['8-12'] },
]
const GRADE_LEVEL_LABELS = GRADE_BAND_FILTER_OPTIONS.map(option => option.label)
const GRID_VIEW_OPTION = { label: "Grid", value: "grid"}
const LIST_VIEW_OPTION = { label: "List", value: "list"}

export default class UnitTemplateMinis extends React.Component {

  constructor(props) {
    super(props)
    document.title = this.formatPageTitle()
  }

  state =  { onMobile: window.innerWidth < 770, currentView: GRID_VIEW_OPTION }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  formatPageTitle() {
    if(this.userLoggedIn()) {
      return getPageTitle('Assign', 'Featured Activity Packs')
    }
    return getPageTitle('Featured Activity Packs')
  }

  updateDimensions = () => {
    const { currentView, onMobile } = this.state
    if(window.innerWidth < 770 !== onMobile) {
      this.setState({ onMobile: window.innerWidth < 770 })
    }
    if(window.innerWidth < 970 && currentView === LIST_VIEW_OPTION) {
      this.setState({ currentView: GRID_VIEW_OPTION })
    }
  }

  getIndexLink() {
    const { signedInTeacher } = this.props;
    return signedInTeacher ? '/assign/featured-activity-packs' : '/activities/packs'
  }

  //adds a final model, which is simply flagged as a createYourOwn one via the key
  addCreateYourOwnModel(models) {
    const { data } = this.props;
    const { non_authenticated } = data;
    if (models && models.length) {
      models.push({id: 'createYourOwn', non_authenticated: non_authenticated, unit_template_category: null });
    }
    return _.uniqBy(models, 'id');
  }

  generateGradeLevelOptions(selectedTypeId) {
    return [ALL].concat(GRADE_LEVEL_LABELS).map((level) => {
      if (level === ALL) {
        return {
          label: level,
          value: null,
          link: `${this.getIndexLink()}${this.generateQueryString(null, selectedTypeId)}`
        }
      }

      return {
        label: level,
        value: level,
        link: `${this.getIndexLink()}${this.generateQueryString(level, selectedTypeId)}`
      }
    })
  }

  generateShowAllGradesView() {
    const { data, } = this.props
    if (data.grade) {
      return (
        <Link className="see-all-activity-packs button-grey button-dark-grey text-center center-block show-all" to={this.getIndexLink()}>Show All Activity Packs</Link>
      )
    }
  }

  generateUnitTemplateView = (model, index, type) => {
    const { actions, signedInTeacher, } = this.props
    return (
      <div className="unit-template-mini-wrapper" key={model.id}>
        {type && index === 0 && <h2 className="pack-type-header" id={`${type}SectionTitle`}>{type}</h2>}
        <UnitTemplateMini
          actions={actions}
          data={model}
          index={index}
          signedInTeacher={signedInTeacher}
        />
      </div>
    )
  };

  getModelCardsByType(models, type) {
    const filteredModels = models.filter(model => {
      const { unit_template_category, id } = model
      if(id === CREATE_YOUR_OWN_ID && type === WHOLE_CLASS_LESSONS)  {
        // we want to include the create your own pack card as the last card in the last section which is Whole Class Lessons
        return model
      }
      if(unit_template_category && type === LANGUAGE_SKILLS) {
        return ACTIVITY_PACK_TYPES.find(type => type.name === LANGUAGE_SKILLS).types.includes(unit_template_category.name)
      }
      if(!unit_template_category) { return }

      return unit_template_category.name === type
    })
    return filteredModels.map((model, index) => {
      return this.generateUnitTemplateView(model, index, type)
    });
  }

  generateUnitTemplateViews() {
    const { signedInTeacher, data, displayedModels, selectedTypeId } = this.props;
    const { grade, } = data;
    let models;
    if (grade) {
      models = _.filter(displayedModels, (m) => {
        return _.contains(m.grades, grade.toString());
      });
    } else {
      models = displayedModels;
    }
    models = _.sortBy(models, 'order_number');
    if (signedInTeacher) {
      models = this.addCreateYourOwnModel(models);
    }
    if(!selectedTypeId) {
      const readingTextModels = this.getModelCardsByType(models, READING_TEXTS)
      const diagnosticModels = this.getModelCardsByType(models, DIAGNOSTIC_CAPITALIZED)
      const languageSkillsModels = this.getModelCardsByType(models, LANGUAGE_SKILLS)
      const dailyProofreadingModels = this.getModelCardsByType(models, DAILY_PROOFREADING)
      const wholeClassModels = this.getModelCardsByType(models, WHOLE_CLASS_LESSONS)
      return(
        <React.Fragment>
          {!!readingTextModels.length && <section className="all-packs-section">
            <section aria-labelledby={`${READING_TEXTS}SectionTitle`} className="packs-section">
              {readingTextModels}
            </section>
          </section>}
          {!!diagnosticModels.length && <section className="all-packs-section">
            <section aria-labelledby={`${DIAGNOSTIC_CAPITALIZED}SectionTitle`} className="packs-section">
              {diagnosticModels}
            </section>
          </section>}
          {!!languageSkillsModels.length && <section className="all-packs-section">
            <section aria-labelledby={`${LANGUAGE_SKILLS}SectionTitle`} className="packs-section">
              {languageSkillsModels}
            </section>
          </section>}
          {!!dailyProofreadingModels.length && <section className="all-packs-section">
            <section aria-labelledby={`${DAILY_PROOFREADING}SectionTitle`} className="packs-section">
              {dailyProofreadingModels}
            </section>
          </section>}
          {!!wholeClassModels.length && <section className="all-packs-section">
            <section aria-labelledby={`${WHOLE_CLASS_LESSONS}SectionTitle`} className="packs-section">
              {wholeClassModels}
            </section>
          </section>}
        </React.Fragment>
      )
    }
    const modelCards = models.map((model, index) => this.generateUnitTemplateView(model, index));
    return modelCards;
  }

  userLoggedIn() {
    const { signedInTeacher, } = this.props
    return signedInTeacher
  }

  userNotLoggedIn() {
    return !this.userLoggedIn();
  }

  handleTypeDropdownChange(type) {
    const { value } = type;
    window.location.href = value;
  }

  getDropdownValue(typeOptionsForDropdown) {
    const { location } = window;
    const { href } = location;

    if(href.includes('diagnostic')) {
      return typeOptionsForDropdown[1];
    } else if(href.includes('whole-class')) {
      return typeOptionsForDropdown[3];
    } else if(href.includes('independent')) {
      return typeOptionsForDropdown[2];
    }
    return typeOptionsForDropdown[0];
  }

  getLabelName(name) {
    switch (name) {
      case 'Whole class lessons':
        return 'Whole class lessons';
      case 'Independent practice':
        return 'Independent'
      default:
        return name;
    }
  }

  generateQueryString(gradeLevel, typeId=null) {
    let qs = ''

    if (gradeLevel) {
      const gradeLevelQuery = `gradeLevel=${gradeLevel}`
      qs+= qs.length ? `&${gradeLevelQuery}` : `?${gradeLevelQuery}`
    }

    if (typeId) {
      const typeQuery = `type=${typeId}`
      qs+= qs.length ? `&${typeQuery}` : `?${typeQuery}`
    }

    return qs
  }

  selectView(option) {
    this.setState({ currentView: option })
  }

  renderFilterOptions() {
    const { onMobile, currentView } = this.state
    const { types, selectedTypeId, data, selectGradeLevel, } = this.props
    const gradeLevelOptions = this.generateGradeLevelOptions(selectedTypeId)
    const currentGradeLevel = gradeLevelOptions.find(cat => cat.value && cat.value === data.selectedGradeLevel)

    const viewOptions = [GRID_VIEW_OPTION, LIST_VIEW_OPTION]

    const baseLink = this.getIndexLink()

    const typeOptions = types.map(type => {
      const { id, name, } = type
      const qs = this.generateQueryString(data.selectedGradeLevel, id)
      return (
        <Link
          className={`focus-on-light ${selectedTypeId === id ? 'active' : ''}`}
          key={id}
          role="tab"
          to={`${baseLink}${qs}`}
        >{name}</Link>
      )
    })

    const typeOptionsForDropdown = types.map(type => {
      const { id, name } = type;
      const qs = this.generateQueryString(data.selectedGradeLevel, id)
      return {
        label: this.getLabelName(name),
        value: `${baseLink}${qs}`
      }
    });
    typeOptionsForDropdown.unshift({ label: 'All Packs', value: '/activities/packs' });

    const allPacksLink = (
      <Link
        className={`focus-on-light ${!selectedTypeId ? 'active' : null}`}
        role="tab"
        to={`${baseLink}${this.generateQueryString(data.selectedGradeLevel)}`}
      >All Packs</Link>
    );

    const typeOptionsWidget = onMobile ? (
      <DropdownInput
        ariaLabel="Pack type"
        className="pack-type-dropdown"
        handleChange={this.handleTypeDropdownChange}
        options={typeOptionsForDropdown}
        value={this.getDropdownValue(typeOptionsForDropdown)}
      />
    ) : (
      <div className='type-options' role="tablist">
        {allPacksLink}
        {typeOptions}
      </div>
    )

    return (
      <div className="filter-options">
        <div className="dropdowns">
          <DropdownInput
            className="grade-level-dropdown focus-on-light"
            handleChange={selectGradeLevel}
            label="Grade level range"
            options={gradeLevelOptions}
            value={currentGradeLevel || gradeLevelOptions[0]}
          />
          <DropdownInput
            className="category-dropdown view-options focus-on-light"
            handleChange={(option) => this.selectView(option)}
            label="View"
            options={viewOptions}
            value={currentView || viewOptions[0]}
          />
        </div>
        {typeOptionsWidget}
      </div>
    )
  }

  renderActivityPacks() {
    const { displayedModels } = this.props;
    const { currentView } = this.state;
    const { value } = currentView;
    if(value === GRID_VIEW_OPTION.value) {
      return(
        <React.Fragment>
          <div className="unit-template-minis">
            {this.generateUnitTemplateViews()}
          </div>
          <div>
            {this.generateShowAllGradesView()}
          </div>
        </React.Fragment>
      )
    }
    if(value === LIST_VIEW_OPTION.value) {
      return(
        <React.Fragment>
          <UnitTemplateMinisTable unitTemplates={displayedModels} userSignedIn={this.userLoggedIn()} />
          <div>
            {this.generateShowAllGradesView()}
          </div>
        </React.Fragment>
      )
    }
  }

  render() {
    return (
      <div className='unit-template-minis-container' key='always-display'>
        {this.userLoggedIn() ? <AssignmentFlowNavigation /> : null}
        <div className="container">
          <main>
            <h1>Select an activity pack for your students.</h1>
            <div>
              {this.renderFilterOptions()}
              {this.generateShowAllGradesView()}
              {this.renderActivityPacks()}
            </div>
          </main>
        </div>
      </div>
    )
  }
}
